export default __webpack_public_path__ + "static/media/home-travel-agency-tour-type-img03.b99c41ea.jpg";